
import { NButton } from '@/uikit';
import { Options, Vue } from 'vue-class-component';
import { languageModule } from '@/store/languages';
import { RouterModule } from '@/store/router';
import { PagePaths } from '@/store/application/page.definitions';
import router from '@/router';
const t = languageModule.getTranslatedToken;

@Options({
  name: 'ReportNotification',
  components: {
    NButton
  }
})
export default class ReportNotification extends Vue {
  clickHandler() {
    router.push(RouterModule.getRouteLocation({ path: PagePaths.Reports }));
  }
  get successfulReportCreationMessage() {
    return t('reports.successful_report_creation');
  }
  get createLabel() {
    return t('reports.reports_page');
  }
}
